import { initializeApp } from 'firebase/app';
import {
  getAuth,
  onAuthStateChanged,
  signOut,
  NextOrObserver,
  User,
  connectAuthEmulator,
  PhoneAuthProvider
} from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'

import {getFirestore, connectFirestoreEmulator} from "firebase/firestore"
import {loadConfig} from './config';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const config = loadConfig();
const app = initializeApp(config);
export const auth = getAuth(app);

export const db = getFirestore(app)

export const storage = getStorage(app)

export const functions = getFunctions(app, "us-central1");
export const phoneAuthProvider = new PhoneAuthProvider(auth);

export const COLLECTIONS = {
  USERS:  'users',
  FEEDS: 'feeds',
  CONTENT_CHANGE_REQUESTS: 'contentChangeRequests',
  CHANNELS: 'channels',
  CHANNEL_CHANGE_REQUESTS: 'channelChangeRequests',
  APPLICATIONS: 'applications',
  REPORTS: 'reports',
  FEEDBACKS: 'feedbacks',
  USER_ACTIONS: 'userActions',
  INVITES: 'invites',
};

export const SUBCOLLECTIONS = {
  CONTENT_USER_ACTIONS: 'userActions',
  CHANNEL_USER_ACTIONS: 'userActions',
  CONTENT_STATUS_LOGS: 'contentStatusLogs',
  CHANNEL_STATUS_LOGS: 'channelStatusLogs',
  APPLICATION_STATUS_LOGS: 'applicationStatusLogs',
  CHANNEL_FOLLOWERS: 'followers',
  USER_ACTIONS_FOLLOWINGS: 'followings',
};


if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.29.141') {
  console.log(window.location.hostname)
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001)
  // Add any other emulators you are using
}else{
  console.log(window.location.hostname)
}

export const userStateListener = (callback:NextOrObserver<User>) => {
  return onAuthStateChanged(auth, callback)
}

export const SignOutUser = async () => await signOut(auth);
  